import { memo, useMemo } from 'react';
import { CampaignAnalytics } from './CampaignAnalytics';
import { SummaryContainer } from './Summary/SummaryContainer';
import { OptimizationContainer } from './Optimization/OptimizationContainer';
import { FlexibleReports } from './FlexibleReports/FlexibleReports';
import { useHasAllChannelsAccess } from '@utils/hooks';
import {
  TabView as BaseTabView,
  TabDefinition,
} from '@features/campaigns/components/TabView';
import { LabelWithBadge } from '@components/shared/LabelWithBadge';

type BuildTabsOptions = {
  showFlexibleReports: boolean;
};

const buildTabs = (options: BuildTabsOptions): TabDefinition[] => [
  { label: 'Summary', component: <SummaryContainer />, path: 'summary' },
  {
    label: 'Real-Time Optimization',
    component: <OptimizationContainer />,
    path: 'real-time-optimization',
  },
  {
    label: 'Campaign Analytics',
    component: <CampaignAnalytics />,
    path: 'campaign-analytics',
  },
  ...(options.showFlexibleReports
    ? [
        {
          label: <LabelWithBadge label="Flexible Reporting" badge="Trial" />,
          component: <FlexibleReports />,
          path: 'flexible-reporting',
        },
      ]
    : []),
];

type TabViewProps = {
  campaignId: number;
};

export const TabView = memo((props: TabViewProps) => {
  const hasAllChannelsAccess = useHasAllChannelsAccess(props.campaignId);
  const showFlexibleReports = hasAllChannelsAccess;
  const tabs = useMemo(
    () => buildTabs({ showFlexibleReports }),
    [showFlexibleReports]
  );

  return <BaseTabView tabs={tabs} />;
});

TabView.displayName = 'TabView';
